import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { CompanyFile } from "@/types";

/**
 * This hook is used to add a new company file to the company files query
 * without refetching the entire query.
 */
export const useAddCompanyFile = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyFileToAdd }: { companyFileToAdd: CompanyFile }) => {
    queryClient.setQueryData(
      ["files", currentCompanyId],
      (cachedData?: CompanyFile[]) => {
        if (!cachedData) return [companyFileToAdd];
        // Important to add the new company file to the top of the list.
        return [companyFileToAdd, ...cachedData];
      },
    );
  };
};
